/**
 *
 */



class DataAnalysisView {

	constructor() {

		this._state = StorageOperator.getStorageData('session', 'state');

		this._or34 = 3;
		if(this._state) {
			this._or34 = this._state.or34 ?  this._state.or34 : 3;
		};
		StorageOperator.storageSetProperty(  'analy34', this._or34 );


		this._resultData = {};
		this._resultData.array = allDataObj.result;

		// nb3
		this._dataAnaly3 = new DataAnalysis( this._resultData, 3);
		this._beanMap3 = this._dataAnaly3.beanMap;

		// nb4
		this._dataAnaly4 = new DataAnalysis( this._resultData, 4);
		this._beanMap4 = this._dataAnaly4.beanMap;

		this._setDataAnaly(this._or34);

		this._index = 0;

		this._rangeArray = this._dataAnaly3.rangeArray;
		this._rangeArrayFig = this._setRangeArrayFig();

		this._canvasInterval = 1;

		this._setOr34Label();

		this._paintAll();

		this._addListener();

	};


	_setRangeArrayFig() {
		let array = [];
		for(let i=0, n=this._rangeArray.length; i<n; i++) {   array.push((''+this._rangeArray[i]).length);   };
		return array;
	};


	_setDataAnaly(or34) {
		if(or34===3) {
			this._dataAnaly = this._dataAnaly3;
			this._setDataAnalyValue();

		}else if(or34===4) {
			this._dataAnaly = this._dataAnaly4;
			this._setDataAnalyValue();
		};
	};

	_setDataAnalyValue() {

		this._baseCountMap = this._dataAnaly.beanMap.get('baseCount');
		this._baseTimesMap = this._dataAnaly.beanMap.get('baseTimes');

	};


	_addListener() {

		MyUtility.setElementEvent( 'navAcd-a', 'click', this._navAcdChange(true), false );

		MyUtility.setElementEvent( 'navBt09', 'click', () => this._numbChange(), false);

		MyUtility.setElementEvent( 'navBt34', 'click', () => this._or34Change(), false);

		MyUtility.setElementEvent( 'canvas2Bt', 'click', () => this._intervalChange(), false);
		MyUtility.setElementEvent( 'canvas4Bt', 'click', () => this._intervalChange(), false);


		MyUtility.setElementEvent( 'canvasDivCenter', 'click', () => this._skipeTop(), false );
		MyUtility.setElementEvent( 'canvasDivBottom', 'click', () => this._skipeTop(), false );

	
		MyUtility.setElementEvent( 'skipTop', 'click', () => this._skipeTop(), false );
		MyUtility.setElementEvent( 'skipBottom', 'click', () => this._skipeBottom(), false );

	};

	//  ナヴィゲーション伸縮　クロージャ
	_navAcdChange(alBoo) {
		let boo = alBoo;
		return function() {
			if(boo) {

				let count = 1;
				let timer = window.setInterval( function() {
					document.getElementById('navAcd-hidde-'+count).style['display'] = 'none';
					count===3 ? window.clearInterval( timer ) : count++;
				}, 50);

				document.getElementsByClassName('outBox')[0].style['padding-top'] = '100px';
				boo = false;
			}else {

				let count = 1;
				let timer = window.setInterval( function() {
					document.getElementById('navAcd-hidde-'+count).style['display'] = 'block';
					count===3 ? window.clearInterval( timer ) : count++;
				}, 50);

				document.getElementsByClassName('outBox')[0].style['padding-top'] = '200px';
				boo = true;
			};
		};
	};




	_or34Change() {

		this._or34 = this._or34===3 ? 4 : 3;

		this._setDataAnaly(this._or34);

		this._index = 0;

		this._setOr34Label();

		this._paintAll();

		StorageOperator.storageSetProperty(  'analy34', this._or34 );
		// iframe 内 html リロード
		document.getElementById('ifra-resultNC').contentWindow.location.reload();

		//  scroll
		const offsetY = window.pageYOffset;

		if(offsetY===0 || offsetY===110) {
			//  スルー
		}else if(offsetY<110) {

			let timer = window.setInterval( () => this._windowScroll( timer, false, 18, 110 ), 12);
			//  _windowScroll メソッド内での clearInterval()が、働かなかった場合の保険
			let timer2 = window.setTimeout( () => window.clearInterval( timer ), 800);
		}else {
			const range = offsetY - 110 > 2000 ? (offsetY - 110)/20 : 90;

			let timer = window.setInterval( () => this._windowScroll( timer, true, range, 110 ), 12);
			//  _windowScroll メソッド内での clearInterval()が、働かなかった場合の保険
			let timer2 = window.setTimeout( () => window.clearInterval( timer ), 1800);
		};

		
	};


	_numbChange() {

		this._indexChange();
		this._paintAll();

		document.getElementById('canvas1Label').textContent = `【 ${this._index} 】の出現個数の分析結果`;
		document.getElementById('canvas2Label').textContent = `【 ${this._index} 】の出現回数の分析結果`;

		const offsY = window.pageYOffset;
		const canvasDivTop = offsY+document.getElementById('canvasDivTop').getBoundingClientRect().top;
		const canvasDivBottom = offsY+document.getElementById('canvasDivBottom').getBoundingClientRect().top;

		const width = window.innerWidth;

		const navDisplay = document.getElementById('navAcd-hidde-1').style.display;
		let navDispOfs = navDisplay==="none" ? 115 : 240;

		let ofsDT = width>591 ? 80 : navDispOfs;

		if(offsY < canvasDivTop-ofsDT) {
			const range = canvasDivTop-ofsDT-offsY > 2000 ? (canvasDivTop-ofsDT-offsY)/20 : 100;

			let timer = window.setInterval( () => this._windowScroll( timer, false, range, canvasDivTop-ofsDT ), 12);
			//  _windowScroll メソッド内での clearInterval()が、働かなかった場合の保険
			let timer2 = window.setTimeout( () => window.clearInterval( timer ), 1500);

		}else if(offsY > canvasDivBottom-(370+ofsDT)) {
			const range = offsY - (canvasDivTop-ofsDT) > 2000 ? (offsY - (canvasDivTop-ofsDT))/20 : 100;

			let timer = window.setInterval( () => this._windowScroll( timer, true, range, canvasDivTop-ofsDT ), 12);
			//  _windowScroll メソッド内での clearInterval()が、働かなかった場合の保険
			let timer2 = window.setTimeout( () => window.clearInterval( timer ), 1500);
		};
	};

	_skipeTop() {

		const offsetY = window.pageYOffset;

		const range = offsetY-110 > 2000 ? (offsetY-110)/20 :  90;

		let timer = window.setInterval( () => this._windowScroll( timer, true, range, 110), 12 );

		//  _windowScroll メソッド内での clearInterval()が、働かなかった場合の保険
		let timer2 = window.setTimeout( () => window.clearInterval( timer ), 800);

	};

	_skipeBottom() {

		const offsetY = window.pageYOffset;
		const windowH = window.innerHeight;

		const footerTop = offsetY+document.getElementById('footerTop').getBoundingClientRect().top;

		const range = footerTop-offsetY > 2000 ? (footerTop-offsetY)/20 : 100;

		let timer = window.setInterval( () => this._windowScroll( timer, false, range, footerTop-windowH ), 12 );

		//  _windowScroll メソッド内での clearInterval()が、働かなかった場合の保険
		let timer2 = window.setTimeout( () => window.clearInterval( timer ), 800);

	};


	_windowScroll( timer, isUpDown, range, end) {

		let offsetY = window.pageYOffset;
		if(isUpDown) {
			if(end>=offsetY) {
				window.clearInterval( timer );
			}else {
				offsetY = offsetY-range < end ? end : offsetY-range;
				window.scroll(0, offsetY);
			};
		}else {
			if(end-5<=offsetY) {
				window.clearInterval( timer );
			}else {
				offsetY = offsetY+range > end ? end : offsetY+range;
				window.scroll(0, offsetY);
			};
		};
	};







	_intervalChange(val) {

		this._canvasInterval = (this._canvasInterval+1)%2;
		this.paintInerval('canvas2', this._baseCountMap.get(this._index));
		this.paintInerval('canvas4', this._baseTimesMap.get(this._index));
	};


	_paintAll() {
		this.paint('canvas1', this._baseCountMap.get(this._index));
		this.paintInerval('canvas2', this._baseCountMap.get(this._index));
		this.paint('canvas3', this._baseTimesMap.get(this._index));
		this.paintInerval('canvas4', this._baseTimesMap.get(this._index));
	}

	_indexChange() {
		for(let i=0; i<10; i++) {
			if(this._index===i) {
				this._index = (this._index+1)%10;
				break;
			};
		};
	};

	_setOr34Label() {
		if(this._or34===3) {
			MyUtility.setElementStyle( 'nb3Img', 'display', 'block' );
			MyUtility.setElementStyle( 'nb4Img', 'display', 'none' );
		}else {
			MyUtility.setElementStyle( 'nb3Img', 'display', 'none' );
			MyUtility.setElementStyle( 'nb4Img', 'display', 'block' );
		};
	};


	//  paint

	paint(cv, bean) {

		const index = this._index;

		const theory = bean.theoryArray;
		const real = bean.realArray;
		const errTheory = bean.errorTheoryArray;

		const theoryValue = bean.theoryValue;

		const headText = bean.headText;

		const realErr = bean.realErrorArray;

		const GRAPH_HI = 150;
		const graph = [];
		for(let i=0, n=this._rangeArray.length; i<n; i++) {
			graph.push(GRAPH_HI*(real[i]/this._rangeArray[i]));
		}
		//
		const GRAPH_HI_ERR = 80;
		const graphErr = [];
		for(let i=0, n=realErr.length; i<n; i++) {
			graphErr.push(GRAPH_HI_ERR/3*( realErr[i]/errTheory[i] ));
		};
		//

		let canvas = document.getElementById( cv );

		if (canvas.getContext) {

			var context = canvas.getContext('2d');

			//  画面クリア
			context.fillStyle =  'rgba(255,255,255,1)';
			context.fillRect(0, 0, 300, 500);


			context.fillStyle =  'rgb(162,238,249)';
			for(let i=0, n=graph.length; i<n; i++) {
				context.fillRect( 45+38*i, 30, 15, GRAPH_HI);
			};
			context.fillStyle =  'rgb(92,168,239)';
			for(let i=0, n=graph.length; i<n; i++) {
				context.fillRect( 45+38*i, 30+GRAPH_HI-graph[i], 15, graph[i]);
			};

			context.fillStyle =  'rgb(162,238,249)';
			if(bean.categ==='baseCount' || bean.categ==='baseTimes') {
				context.fillRect( 10, 10, 19, 19);
			};
			context.fillRect( 2, 217, 296, 20);

			//  text
			context.fillStyle = 'rgb(0, 0, 0)';
			context.font = "18px 'Meiryo'";
			context.textAlign = "left";
			context.textBaseline = "top";
			if(bean.categ==='baseCount' || bean.categ==='baseTimes') {
				context.fillText( index,  14, 6, 20);
			};
			context.font = "17px 'Meiryo'";
			context.fillText('の各範囲ごとの'+ headText, 32, 6, 180 );

			context.font = "12px 'Meiryo'";

			let thFig = this._getNumbFigArray(theory);
			let couFig = this._getNumbFigArray(real);

			for(let i=0, n=this._rangeArray.length; i<n; i++) {

				context.fillText( Math.round(theory[i]),  45+38*i-(thFig[i]-2)*3.25, 32+GRAPH_HI, 30);

				context.fillText( real[i],  45+38*i-(couFig[i]-2)*3.25, 47+GRAPH_HI, 30);

				context.fillText( this._rangeArray[i],  45+38*i-(this._rangeArrayFig[i]-2)*3.25, 67+GRAPH_HI, 30);
			};

			const ofs = GRAPH_HI+30-( GRAPH_HI*theoryValue/100 );
			context.fillText( theoryValue.toFixed(1)+'%',  2, ofs-8, 30);

			context.fillText( '理論値', 2, 32+GRAPH_HI, 30);
			context.fillText( '実値', 2, 47+GRAPH_HI, 30);
			context.fillText( 'レンジ', 2, 67+GRAPH_HI, 30);

			//  stroke
			this._paintStroke( context, 'rgb(25, 85, 229)', 40, ofs, 295, ofs);

			//
			//
			const top_ofs = 260;
			const errRange = GRAPH_HI_ERR/3;
			const center_line = top_ofs+GRAPH_HI_ERR;
			const errLine_over = center_line-errRange;
			const errLine_under = center_line+errRange;

			context.fillStyle = 'rgb(162,238,249)';
			for(let i=0, n=graph.length; i<n; i++) {
				context.fillRect( 45+38*i, top_ofs, 15, GRAPH_HI_ERR*2);
			};
			context.fillStyle = 'rgb(205,246,255)';
			for(let i=0, n=graph.length; i<n; i++) {
				context.fillRect( 45+38*i, errLine_over, 15, errRange*2);
			};
			context.fillStyle = 'rgb(92,168,239)';
			for(let i=0, n=graphErr.length; i<n; i++) {
				if(graphErr[i]>0) {
					let len = graphErr[i] > GRAPH_HI_ERR ? GRAPH_HI_ERR : graphErr[i];
					context.fillRect( 45+38*i, center_line-len, 15, len);
				}else if(graphErr[i]<0) {
					let abs = Math.abs(graphErr[i]);
					abs = abs > GRAPH_HI_ERR ? GRAPH_HI_ERR : abs;
					context.fillRect( 45+38*i, center_line, 15, abs);
				};
			};

			//  stroke
			this._paintStroke( context, 'rgb(15, 25, 55)', 40, center_line+0.4, 295, center_line);
			this._paintStroke( context, 'rgb(50, 110, 235)', 40, errLine_over, 295, errLine_over);
			this._paintStroke( context, 'rgb(50, 110, 235)', 40, errLine_under, 295, errLine_under);


			//  text
			context.fillStyle = 'rgb(0, 0, 0)';
			for(let i=0, n=graphErr.length; i<n; i++) {
				if(graphErr[i]>0) {
					if( graphErr[i] > GRAPH_HI_ERR ) {
						context.fillText('over', 40+38*i, top_ofs, 30);
					};
				}else if(graphErr[i]<0) {
					let abs = Math.abs(graphErr[i]);
					if( abs > GRAPH_HI_ERR ) {
						context.fillText('over', 40+38*i, top_ofs+GRAPH_HI_ERR*2-20, 30);
					};
				};
			};

			context.fillText( '理差＋', 2, errLine_over-8, 30);
			context.fillText( '理論値', 2, center_line-8, 30);
			context.fillText( '理差ー', 2, errLine_under-8, 30);


			let errThFig = this._getNumbFigArray(errTheory);
			let realErrFig = this._getNumbFigArray(realErr);

			for(let i=0, n=this._rangeArray.length; i<n; i++) {

				context.fillText( Math.round(errTheory[i]),  45+38*i-(errThFig[i]-2)*3.25, top_ofs+2+GRAPH_HI_ERR*2, 30);
				context.fillText( Math.round(realErr[i]),  45+38*i-(realErrFig[i]-2)*3.25, top_ofs+17+GRAPH_HI_ERR*2, 30);
			};

			context.fillText( '理差', 2, top_ofs+2+GRAPH_HI_ERR*2, 30);
			context.fillText( '実値', 2, top_ofs+17+GRAPH_HI_ERR*2, 30);

		};
	};

	_paintStroke( context, style, x1, y1, x2, y2 ) {
		context.beginPath();
		context.strokeStyle = style;
		context.moveTo(x1, y1);
		context.lineTo(x2, y2);
		context.stroke();
		context.closePath();
	};




	paintInerval(cv, bean) {

		const index = this._index;

		const val = this._canvasInterval;

		let zz50Ct = new Array();
		let zz20Ct = new Array();
		let zz10Ct = new Array();
		let zz5Ct = new Array();

		let itvMap50 = bean.intervalCountArray[3];
		let itvMap20 = bean.intervalCountArray[2];
		let itvMap10 = bean.intervalCountArray[1];
		let itvMap5 = bean.intervalCountArray[0];


		for(var i=0, n=itvMap50.length; i<n; i++) {
			zz50Ct[i] = itvMap50[i]/50*120;
			zz20Ct[i] = itvMap20[i]/20*120;
			zz10Ct[i] = itvMap10[i]/10*120;
			zz5Ct[i] = itvMap5[i]/5*120;
		};

		let thV = bean.intervalTheoryArray;


		let indStart = this._rangeArray[this._rangeArray.length-1];

		let range50Top = indStart-50*10;
		let range20Top = indStart-20*10;
		let range10Top = indStart-10*10;
		let range5Top = indStart-5*10;

		const theoryValue = bean.theoryValue;
		const headText = bean.headText;


		let canvas = document.getElementById( cv );

		if (canvas.getContext) {

			let context = canvas.getContext('2d');

			//  画面クリア
			context.fillStyle =  'rgba(255,255,255,1)';
			context.fillRect(0, 0, 300, 500);

			context.fillStyle =  'rgb(162,238,249)';
			if(bean.categ==='baseCount' || bean.categ==='baseTimes') {
				context.fillRect( 10, 10, 19, 19);
			};

			context.fillStyle = 'rgb(0, 0, 0)';
			context.font = "18px 'Meiryo'";
			context.textAlign = "left";
			context.textBaseline = "top";
			if(bean.categ==='baseCount' || bean.categ==='baseTimes') {
				context.fillText( index,  14, 6, 20);
			};
			context.font = "17px 'Meiryo'";
			context.fillText('の各間隔ごとの'+ headText, 32, 6, 180 );


			if(val==0) {
				this.paint3Sub(context, itvMap50, thV[3].toFixed(1), zz50Ct, 25 , range50Top, 50, theoryValue );

				this.paint3Sub(context, itvMap20, thV[2].toFixed(1), zz20Ct, 255, range20Top, 20, theoryValue );
			}else {
				this.paint3Sub(context, itvMap10, thV[1].toFixed(1), zz10Ct, 25 , range10Top, 10, theoryValue );

				this.paint3Sub(context, itvMap5, thV[0].toFixed(1), zz5Ct, 255, range5Top, 5, theoryValue );
			};
		};
	};



	paint3Sub( context ,zz5020Arr, zz52, zzCt, ofsY, rangeTop, range, theoryValue ) {

		context.fillStyle = 'rgb(162,238,249)';
		for(var i=0; i<10; i++) {
			context.fillRect(150, 20+i*20+ofsY, 120, 13);
		};

		context.fillRect(25, 65+ofsY, 80, 100);

		context.fillStyle = 'rgb(92,168,239)';
		for(var i=0; i<10; i++) {
			context.fillRect(150, 20+i*20+ofsY, zzCt[9-i], 13);
		};

		context.fillStyle = '#000000';

		context.textAlign = "center";
		context.textBaseline = "top";

		context.font = "16px 'Meiryo'";

		context.fillText( "間隔. "+range, 65, 75+ofsY, 95);

		context.font = "15px 'Meiryo'";

		context.fillText( "理論値", 65, 115+ofsY, 60);
		context.fillText( zz52, 65, 137+ofsY, 60);

		for(var i=0; i<10; i++) {
			context.fillText( zz5020Arr[9-i], 135, 18+i*20+ofsY, 60);
		};

		context.textAlign = "left";
		context.fillText( '~ '+(rangeTop+1)+'回', 48, 18+ofsY, 60);
		context.fillText( rangeTop+range*10+'回 ~', 48, 197+ofsY, 60);

		//
		context.beginPath();
		context.strokeStyle = 'rgb(25, 85, 85)';
		var ofs = 150+( 120 * theoryValue/100 );
		context.moveTo(ofs, 18+ofsY);
		context.lineTo(ofs, 215+ofsY);
		context.stroke();
		context.closePath();

		context.textAlign = "center";
		context.font = "14px 'Meiryo'";
		context.fillText(range, 266, 2+ofsY, 30);
		context.fillText( zz52, ofs, 2+ofsY, 40);
	};




	_getNumbFigArray(array) {
		let lenArr = [];
		for(let i=0, n=array.length; i<n; i++) {
			lenArr.push((''+Math.round(array[i])).length);
		};
		return lenArr;
	};



};




